// import React from "react";
// import ReactDOM from "react-dom/client";
// import "./App.css";
// import App from "./App";
// import { BrowserRouter } from "react-router-dom";
// import UserProvider from "./components/context/UserProvider";
// import "primereact/resources/themes/lara-light-cyan/theme.css";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       <UserProvider>
//         <App />
//       </UserProvider>
//     </BrowserRouter>
//   </React.StrictMode>
// );

import React from "react";
import ReactDOM from "react-dom/client";
import "./App.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import UserProvider from "./components/context/UserProvider";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { HelpProvider } from "./components/Help/HelpContext";

import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <UserProvider>
          <HelpProvider>
            <App />
          </HelpProvider>
        </UserProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
